import { gql } from '@apollo/client';

const CREATE_ACCESS_ACTIVITY_PAGE_EVENT = gql`
  mutation createAccessActivityPageEvent($data: AccessActivityPageEventCreateInput!) {
    createAccessActivityPageEvent(data: $data)
  }
`;

export default CREATE_ACCESS_ACTIVITY_PAGE_EVENT;
